var title_bar_filter = (function( $ ) {

	var _init = function() {
		therapeutic_area_filter_dropdown()
	};

	function therapeutic_area_filter_dropdown() {
		$ta_filter = $( '#ta-filter-wrapper' );

		if ( $ta_filter.length > 0 ) {
			$select = $( '.ta-filter-select2' ).select2( {
				placeholder:             'Select Therapeutic Area',
				minimumResultsForSearch: Infinity,
				dropdownParent:          $ta_filter
			} );

			$select.data( 'select2' ).$dropdown.addClass( 'ta-filter-dropdown' );
			$select.data( 'select2' ).$container.addClass( 'ta-filter-select-wrapper' );

			$ta_filter.on( 'change', function() {
				$( '#ta-filter-wrapper' ).submit();

				var selectedValue = $( "#ta-filter option:selected" ).val();
				var currentUrlWithoutQuery = window.location.origin + window.location.pathname;

				var urlSegments = currentUrlWithoutQuery.split( '/' );

				if ( ! urlSegments.includes( 'videos-webinars' ) && ( ! urlSegments.includes( 'interactive-content' ) ) ) {

					if ( urlSegments.includes( 'type' ) ) {
						while ( urlSegments[ urlSegments.length - 2 ] !== 'type' ) {
							urlSegments.pop();
						}
					}

					if ( urlSegments.includes( 'journal' ) ) {
						while ( urlSegments[ urlSegments.length - 1 ] !== 'journal' ) {
							urlSegments.pop();
						}
					}

				} else {
					if ( urlSegments.includes( 'videos-webinars' ) ) {
						while ( urlSegments[ urlSegments.length - 1 ] !== 'videos-webinars' ) {
							urlSegments.pop();
						}
					}

					if ( urlSegments.includes( 'interactive-content' ) ) {
						while ( urlSegments[ urlSegments.length - 1 ] !== 'interactive-content' ) {
							urlSegments.pop();
						}
					}
				}

				urlSegments.push( selectedValue );

				window.location.href = urlSegments.join('/');
			} );
		}
	}

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = title_bar_filter;